import React from 'react';
import { BsEmojiFrown } from 'react-icons/bs';
import { OnestBoldMed, OnestNormalDefault } from '../../styled/TextComponents';
import { color_grey_dark, color_grey_ultra_light } from '../../../constants/colors';
import { useWindowDimensions } from '../../../utils';
import { useI18n } from '../../../i18n/I18nProvider';

const NoFilesPlaceholder = ({ searchValue }) => {
    const { t } = useI18n();
    const { width: screenWidth } = useWindowDimensions();

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '300px',
            gap: 20,
            padding: 40,
            textAlign: 'center'
        }}>
            <BsEmojiFrown 
                style={{
                    fontSize: 60,
                    color: color_grey_ultra_light
                }}
            />
            <OnestBoldMed style={{ color: color_grey_dark }}>
                {searchValue && searchValue.trim() !== '' 
                    ? t('По запросу "{{searchValue}}" ничего не найдено', { searchValue })
                    : t('Файлы не найдены')
                }
            </OnestBoldMed>
            <OnestNormalDefault style={{ color: color_grey_dark, maxWidth: screenWidth > 530 ? 400 : screenWidth - 80 }}>
                {searchValue && searchValue.trim() !== ''
                    ? t('Попробуйте изменить поисковый запрос или очистить фильтр')
                    : t('В библиотеке пока нет доступных файлов')
                }
            </OnestNormalDefault>
        </div>
    );
};

export default NoFilesPlaceholder;